module.exports = __webpack_public_path__ + "img/72.8.TSS.ebfe7c36.png";